@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import './mixins.scss';

$text-field-btn-bottom: 0.45rem;

.autocomplete {
  position: relative;
  width: 100%;
}

.input {
  pointer-events: none;
  position: relative;
  width: 100%;

  .textInputContainer {
    @include barlow(16);
    display: inline-grid;
    pointer-events: auto;
    width: 100%;

    .noLabel {
      margin-top: 0;
    }

    .hasLabel {
      margin-top: 0.3125rem;
    }

    input {
      padding-left: $padding + 1.5rem;
      padding-right: $padding + 2rem;
    }

    .textInputLabel {
      color: _palette(text-primary);
      margin-top: 0.125rem;

      &:hover {
        & > label {
          color: _palette(secondary);
        }

        & > input {
          border: $border-width-thick solid _palette(secondary);
          padding-left: $padding-large-border + 1.5rem;
          padding-right: $padding-large-border + 2rem;
        }
      }

      .required {
        color: _palette(text-red);
        font-weight: 600;
      }
    }

    .fakeHoverLabel {
      color: _palette(secondary);
    }

    .fakeHoverBorder {
      border: $border-width-thick solid _palette(secondary);
    }

    .textInputBorder {
      border: $border-width solid _palette(black-25);
    }

    .textInput {
      background-color: _palette(bg-secondary);
      border-radius: 5px;
      color: _palette(text);
      font-size: 1rem;
      outline: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      height: $inputHeight;

      &:disabled {
        background-color: _palette(text-secondary);
      }

      &:hover {
        border-color: _palette(secondary);
        border-width: $border-width-thick;
      }

      &:focus,
      &:focus:hover {
        border-color: _palette(secondary);
        border-width: $border-width-thick;
      }
    }

    .textInput.clicked {
      &:focus,
      &:focus:hover {
        border-color: _palette(secondary) _palette(secondary) _palette(black-25)
          _palette(secondary);
        border-radius: 5px 5px 0 0;
        border-width: $border-width-thick;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
        outline: none;
      }
    }
  }

  .multipleValues {
    @include barlow(16);
    position: absolute;
    background-color: _palette(bg-secondary);
    color: _palette(links);
    overflow: hidden;
    margin: 0.625rem $border-width-thick;
    padding: 0 3.125rem 0 2.2rem;
    bottom: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - (2 * #{$border-width-thick}));
  }

  .arrow {
    bottom: $text-field-btn-bottom;
    height: 1.5rem;
    pointer-events: auto;
    position: absolute;
    right: 0.5rem;
    width: 1.5rem;

    .arrowSvg {
      border-radius: 50%;
      transition: all 0.25s;
    }

    &:focus {
      outline: none;

      .arrowSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }

    &:hover {
      .arrowSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }
  }

  svg {
    fill: _palette(text-primary);
  }

  .search {
    bottom: $text-field-btn-bottom;
    left: 0.35rem;
    pointer-events: none;
    position: absolute;
  }

  .clear {
    bottom: $text-field-btn-bottom;
    height: 1.5rem;
    pointer-events: auto;
    position: absolute;
    right: 2rem;
    width: 1.5rem;

    .clearSvg {
      border-radius: 50%;
      transition-duration: 0.25s;
      transition-property: fill;
    }

    &:focus {
      outline: none;

      .clearSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }

    &:hover {
      .clearSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }
  }
}

.dropdownBorder {
  border: $border-width-thick solid _palette(secondary);
  border-radius: 0 0 5px 5px;
  border-top: 0;
}

.dropdownmenu {
  background-color: _palette(bg-secondary);
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.5);
  height: auto;
  left: 0;
  max-height: 30vh;
  overflow-y: auto;
  position: absolute;
  right: 0;
  z-index: 1300;

  %dropdownitem {
    color: _palette(text-primary);
    height: 2.25rem;
    padding: 0.5rem 0.5rem 0.5rem 0;
    display: flex;

    .helpButton {
      position: relative;
      right: -2%;
      min-width: 10%;
      height: 1.5rem;
    }

    .dropdownItemText {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90%;
    }

    & > * {
      vertical-align: middle;
    }

    &,
    & > * {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      background-color: #f2faff;
      cursor: pointer;

      .checkbox {
        * {
          color: _palette(secondary-dark);
        }
      }

      .checkboxOutline {
        * {
          color: _palette(secondary-dark);
        }
      }
    }

    &:focus {
      background-color: #f2faff;
      outline: none;

      .checkbox {
        * {
          color: _palette(secondary-dark);
        }
      }

      .checkboxOutline {
        * {
          color: _palette(secondary-dark);
        }
      }
    }

    %checkboxCommon {
      margin-right: 0.5rem;
      padding: 0.1rem;
    }

    .checkbox {
      @extend %checkboxCommon;

      * {
        color: _palette(secondary);
      }

      &:hover,
      &:focus {
        * {
          color: _palette(secondary-dark);
        }
      }
    }

    .checkboxDisabled {
      @extend %checkboxCommon;
    }

    .checkboxOutline {
      @extend %checkboxCommon;

      &:hover,
      &:focus {
        * {
          color: _palette(secondary);
        }
      }
    }
  }

  .dybde0 {
    @extend %dropdownitem;
    @include barlow(16);
    color: _palette(secondary-dark);
  }

  .dybde1 {
    @extend %dropdownitem;
    @include barlow(16, 500);
    color: _palette(secondary-dark);
    text-transform: uppercase;
  }

  .dybde2 {
    @extend %dropdownitem;
    @include barlow(16);
  }

  .dybde3 {
    @extend %dropdownitem;
    @include barlow(16);
  }

  .dybdeDefault {
    @extend %dropdownitem;
    @include barlow(16);
    padding-left: 0.5rem;
  }

  .disabledItem {
    color: _palette(text-secondary);

    &:hover,
    &:focus {
      background-color: _palette(bg-secondary);
      cursor: default;
    }
  }

  .disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  .searchString {
    color: _palette(secondary);
    font-weight: 600;
  }
}
